// extracted by mini-css-extract-plugin
export default {"visible-false":"LinkDetailsPopup_visible-false__0MG07","visible-true":"LinkDetailsPopup_visible-true__yrUEZ"};